const SET_QUOTE = 'directOrder/SET_QUOTE';
const CLEAN_QUOTE = 'directOrder/CLEAN_QUOTE';

const SET_QUOTE_ERROR = 'directOrder/SET_QUOTE_ERROR';
const CLEAN_QUOTE_ERROR = 'directOrder/CLEAN_QUOTE_ERROR';

export default {
  SET_QUOTE,
  CLEAN_QUOTE,

  SET_QUOTE_ERROR,
  CLEAN_QUOTE_ERROR,
};
